import { VoiceAgentTool, VoiceToolName, VoiceToolPressDTMFParams } from '@numeo/types'

export const convertVoiceAgentToolCallToMessage = (toolCall?: VoiceAgentTool) => {
    if (!toolCall) return ''
    try {
        switch (toolCall.toolName) {
            case VoiceToolName.COLLECT_LOAD_DETAILS:
                return `AI updated load details - ${Object.entries(typeof toolCall.parameters === 'object' && toolCall.parameters ? toolCall.parameters : {})
                    .filter(([, value]) => value)
                    .map(([key, value]) => (['string', 'number', 'boolean'].includes(typeof value) ? `${key}: ${value}` : `${key}: ${JSON.stringify(value)}`))
                    .join(', ')}`
            case VoiceToolName.PRESS_DTMF:
                return `AI pressed: ${(toolCall.parameters as VoiceToolPressDTMFParams)?.dtmf}`
            case VoiceToolName.HANGUP_CALL:
                return `AI ended the call`
            case VoiceToolName.REQUEST_HUMAN_DISPATCHER:
                return `AI requested human dispatcher`
            default:
                return `Tool call: ${toolCall.toolName}`
        }
    } catch (error) {
        console.error('Error converting tool call to message:', error)
        return `Tool call: ${toolCall.toolName}`
    }
}
